<template>
  <v-container
    fluid
    :class="['top-menu', isDaytimeAdviceRoute ? 'top-menu--compact pa-0' : 'pa-8']"
  >
    <v-app-bar
      :color="isDaytimeAdviceRoute ? '#3ACAC9' : 'grey-lighten-4'"
      :class="isDaytimeAdviceRoute ? 'app-nav-bar text-white' : themeClasses.text"
      :height="isDaytimeAdviceRoute ? 48 : undefined"
    >
      <v-row
        :no-gutters="isDaytimeAdviceRoute"
        :class="isDaytimeAdviceRoute ? 'app-nav-row' : 'pa-2'"
        :align="isDaytimeAdviceRoute ? 'center' : undefined"
        :align-content="isDaytimeAdviceRoute ? undefined : 'center'"
      >
        <v-col
          v-if="isDaytimeAdviceRoute"
          align-self="center"
          sm="5"
          md="2"
          class="hidden-xs app-nav-title-col"
          style="padding-left: 8px;"
        >
          <router-link
            class="app-nav-title"
            :to="{ path: '/reservations/list'}"
          >
            KP相談カルテ
          </router-link>
        </v-col>
        <v-col
          v-else
          align-self="center"
          sm="5"
          md="2"
          class="hidden-xs"
        >
          <v-spacer />
          <v-toolbar
            color="grey-lighten-4"
            :class="themeClasses.text"
          >
            <router-link
              v-slot="{ navigate }"
              :to="{ path: '/reservations/list'}"
              custom
            >
              <v-toolbar-title @click="navigate">
                KP相談カルテ
              </v-toolbar-title>
            </router-link>
          </v-toolbar>
        </v-col>
        <v-col
          v-if="!isDaytimeAdviceRoute || hasSearchListener"
          align-self="center"
          cols="11"
          sm="6"
          md="3"
          :class="isDaytimeAdviceRoute ? 'd-flex align-center' : undefined"
        >
          <div
            :class="isDaytimeAdviceRoute ? 'app-nav-search d-flex align-center' : undefined"
            :style="isDaytimeAdviceRoute ? undefined : 'height:50px'"
          >
            <v-menu
              v-if="hasSearchListener"
              bottom
              offset-y
              min-width="auto"
              transition="fade-transition"
            >
              <template #activator="{ on }">
                <VueDatePicker
                  v-model="date"
                  locale="jp"
                  format="yyyy-MM-dd"
                  model-type="yyyy-MM-dd"
                  :teleport="true"
                  :enable-time-picker="false"
                  :clearable="false"
                  auto-apply
                  :min-date="hasOperatorAccess ? null : formattedViewLimitDateFrom"
                  @update:model-value="$emit('search', date)"
                />
              </template>
            </v-menu>
          </div>
        </v-col>
        <v-col
          :align-self="isDaytimeAdviceRoute ? 'stretch' : 'center'"
          :class="isDaytimeAdviceRoute ? 'd-flex align-stretch justify-end' : 'pa-4'"
          :cols="isDaytimeAdviceRoute && !hasSearchListener ? 12 : 1"
          :sm="isDaytimeAdviceRoute && !hasSearchListener ? 7 : 1"
          :md="isDaytimeAdviceRoute && !hasSearchListener ? 10 : 7"
        >
          <!-- 折りたたまないメニュー -->
          <v-toolbar-items
            :class="isDaytimeAdviceRoute ? 'justify-end hidden-md-and-down app-nav-tabs' : 'justify-end hidden-sm-and-down'"
          >
            <v-btn
              v-if="canAccessHighRisk"
              :to="{ path: '/face_sheets' }"
              variant="text"
              :color="isDaytimeAdviceRoute ? 'white' : themeClasses.color"
              :prepend-icon="isDaytimeAdviceRoute ? 'mdi-emoticon-outline' : undefined"
              :class="isDaytimeAdviceRoute ? ['app-nav-tab', { 'app-nav-tab--active': isActiveSection('faceSheets') }] : 'pa-0'"
              :style="navOrderStyle('faceSheets')"
            >
              フェイスシート
            </v-btn>
            <v-btn
              v-if="canAccessNightConsultation"
              :to="{ name: 'list', query: { date: $route.query.date }}"
              variant="text"
              :color="isDaytimeAdviceRoute ? 'white' : themeClasses.color"
              :prepend-icon="isDaytimeAdviceRoute ? 'mdi-weather-night' : undefined"
              :class="isDaytimeAdviceRoute ? ['app-nav-tab', { 'app-nav-tab--active': isActiveSection('night') }] : 'pa-0'"
              :style="navOrderStyle('night')"
            >
              夜間相談
            </v-btn>
            <v-btn
              v-if="canAccessAnytimeConsultation"
              :to="{ path: '/anytime_consultations', query: { tab_id: '0', department: 1, complete: 0 } }"
              variant="text"
              :color="isDaytimeAdviceRoute ? 'white' : themeClasses.color"
              :prepend-icon="isDaytimeAdviceRoute ? 'mdi-email-outline' : undefined"
              :class="isDaytimeAdviceRoute ? ['app-nav-tab', { 'app-nav-tab--active': isActiveSection('anytime') }] : 'pa-0'"
              :style="navOrderStyle('anytime')"
            >
              いつでも相談
            </v-btn>
            <v-btn
              v-if="canAccessDaytimeAdvice"
              :to="{ name: 'daytimeAdviceRoom' }"
              variant="text"
              :color="isDaytimeAdviceRoute ? 'white' : themeClasses.color"
              :prepend-icon="isDaytimeAdviceRoute ? 'mdi-comment-outline' : undefined"
              :class="isDaytimeAdviceRoute ? ['app-nav-tab', { 'app-nav-tab--active': isActiveSection('daytime') }] : 'pa-0'"
              :style="navOrderStyle('daytime')"
            >
              日中助産師
            </v-btn>
            <v-btn
              v-if="hasOperatorAccess"
              :to="{ name: 'shift', query: {date: $route.query.date}}"
              variant="text"
              :color="isDaytimeAdviceRoute ? 'white' : themeClasses.color"
              :prepend-icon="isDaytimeAdviceRoute ? 'mdi-calendar-clock' : undefined"
              :class="isDaytimeAdviceRoute ? ['app-nav-tab', 'app-nav-tab--shift', { 'app-nav-tab--active': isActiveSection('shift') }] : 'pa-0'"
              :style="navOrderStyle('shift')"
            >
              夜間シフト
            </v-btn>
            <v-btn
              v-if="hasOperatorAccess"
              :to="{ name: 'ac_shift', query: {date: $route.query.date}}"
              variant="text"
              :color="isDaytimeAdviceRoute ? 'white' : themeClasses.color"
              :prepend-icon="isDaytimeAdviceRoute ? 'mdi-calendar-check-outline' : undefined"
              :class="isDaytimeAdviceRoute ? ['app-nav-tab', 'app-nav-tab--shift', { 'app-nav-tab--active': isActiveSection('acShift') }] : 'pa-0'"
              :style="navOrderStyle('acShift')"
            >
              いつでもシフト
            </v-btn>
            <!-- <v-btn text color="pink">アカウント</v-btn> -->
            <v-btn
              variant="text"
              :color="isDaytimeAdviceRoute ? 'white' : themeClasses.color"
              :prepend-icon="isDaytimeAdviceRoute ? 'mdi-logout' : undefined"
              :class="isDaytimeAdviceRoute ? 'app-nav-tab' : 'pa-0'"
              :style="navOrderStyle('logout')"
              @click="$emit('logout')"
            >
              ログアウト
            </v-btn>
          </v-toolbar-items>
          <!-- 折りたたみメニュー表示ボタン -->
          <v-app-bar-nav-icon
            :class="isDaytimeAdviceRoute ? 'hidden-lg-and-up' : 'hidden-md-and-up'"
            @click="drawer = true"
          />
        </v-col>
      </v-row>
    </v-app-bar>
    <!-- 折りたたみメニュー -->
    <v-navigation-drawer
      v-model="drawer"
      position="absolute"
      location="right"
      temporary
    >
      <v-list
        nav
        density="compact"
      >
        <v-list-group
          class="text--accent-4"
          active-class="font-weight-bold"
        >
          <v-list-item
            v-if="canAccessHighRisk"
            link
            :to="{ path: '/face_sheets' }"
          >
            <v-list-item-title>
              フェイスシート
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="canAccessNightConsultation"
            link
            :to="{ name: 'list', query: { date: $route.query.date }}"
          >
            <v-list-item-title class="pink--text">
              夜間相談
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="canAccessAnytimeConsultation"
            link
            :to="{ path: '/anytime_consultations', query: { tab_id: '0' } }"
          >
            <v-list-item-title class="pink--text">
              いつでも相談
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="canAccessDaytimeAdvice"
            link
            :to="{ name: 'daytimeAdviceRoom' }"
          >
            <v-list-item-title class="pink--text">
              日中助産師
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="hasOperatorAccess"
            link
            :to="{ name: 'shift', query: {date: $route.query.date}}"
          >
            <v-list-item-title class="pink--text">
              夜間シフト
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="hasOperatorAccess"
            link
            :to="{ name: 'ac_shift', query: {date: $route.query.date}}"
          >
            <v-list-item-title class="pink--text">
              いつでもシフト
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="$emit('logout')"
          >
            <v-list-item-title class="pink--text">
              ログアウト
            </v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ondutyReservationViewLimitMixin from "../../mixins/onduty_reservation_view_limit.js";
import environmentMixin from "../../mixins/environment.js";

export default {
  name: "TopMenu",
  mixins: [ondutyReservationViewLimitMixin, environmentMixin],
  props: {
    onSearch: {
      type: Function,
      default: null
    },
  },
  emits: ["search", "logout"],
  data: () => ({
    date: null,
    drawer: false
  }),
  computed: {
    ...mapGetters(["currentDoctor", "hasAllCapabilities"]),
    formattedViewLimitDateFrom : function (){
      return this.formatDate(this.viewLimitDateFrom);
    },
    today: function() {
      return this.formatDate(new Date());
    },
    hasSearchListener: function() {
      return this.onSearch;
    },
    hasOperatorAccess: function(){
      return this.hasAllCapabilities(["operator:access"]);
    },
    canAccessNightConsultation: function() {
      return this.hasAllCapabilities(["night_consultation:access"]);
    },
    canAccessAnytimeConsultation: function() {
      return this.hasAllCapabilities(["anytime_consultation:access"]);
    },
    canAccessDaytimeAdvice: function() {
      return this.hasAllCapabilities(["daytime_advice:access"]);
    },
    canAccessHighRisk: function() {
      return this.hasAllCapabilities(["high_risk:access"]);
    },
    isDaytimeAdviceRoute: function() {
      return this.$route.path.startsWith("/daytime_advices");
    },
  },
  watch: {
    "$route" () {
      this.date = this.$route.query.date ? this.$route.query.date : this.today;
    },
  },
  created() {
    this.date = this.$route.query.date ? this.$route.query.date : this.today;
  },
  methods: {
    formatDate(date){
      return ("0000" + date.getFullYear()).slice(-4) + "-" + ("00" + (date.getMonth() + 1)).slice(-2) + "-" + ("00" + (date.getDate())).slice(-2);
    },
    isActiveSection(section) {
      const pathPrefixes = {
        faceSheets: "/face_sheets",
        night: "/reservations",
        anytime: "/anytime_consultations",
        daytime: "/daytime_advices",
        shift: "/shifts",
        acShift: "/anytime_consultation_shifts",
      };
      const prefix = pathPrefixes[section];
      return !!prefix && this.$route.path.startsWith(prefix);
    },
    navOrderStyle(section) {
      if (!this.isDaytimeAdviceRoute) return undefined;
      const orders = {
        faceSheets: 1,
        night: 2,
        anytime: 3,
        daytime: 4,
        logout: 5,
        shift: 6,
        acShift: 7,
      };
      return { order: orders[section] };
    }
  }
};
</script>

<style lang="scss">
.top-tab.v-theme--light.v-tabs-bar {
  background-color: rgba(100, 100, 100, 0.2) !important;
}
.dp__input {
  border-radius: var(--dp-border-radius, 6px);
  line-height: 2.15rem;
}
.dp__theme_light {
  --dp-highlight-color: rgba(34, 233, 8, 0.993);
  --dp-primary-color: #ff006f;
  --dp-primary-text-color: #000078;
}
.dp__cell_inner {
  --dp-cell-border-radius: 50%;
}
.v-alert + div > .top-menu > .v-toolbar {
  top: 60px !important;
}
.v-alert + div > .v-tabs {
  margin-top: 60px !important;
}

/* ナビゲーションバー（/daytime_advices 配下のみ適用） */
.top-menu--compact {
  /* v-app-barはposition: fixedなので、この高さで後続コンテンツ用のスペーサーを確保する */
  height: 48px;
}

.app-nav-bar {
  .v-toolbar__content {
    align-items: stretch;
    padding-top: 0;
    padding-bottom: 0;
  }
}

.app-nav-row {
  height: 100%;
  flex-wrap: nowrap; /* 列幅の中途の丸め誤差により本来不要な折り返しが発生し、タイトルが下にずれたりハンバーガーが右端に並ばなくなるのを防ぐ */
}

// Vuetifyの hidden-xs は display: none !important で制御されるため、
// 縦中央揃えは !important を使わない専用クラスで指定する。
// (d-flex 等のユーティリティクラスも !important 付きのため、CSSの定義順によっては
//  hidden-xs の display: none を上書きしてしまい、狭い画面幅でタイトル列が消えず
//  ハンバーガーメニューが画面外に押し出される不具合が発生していた)
.app-nav-title-col {
  display: flex;
  align-items: center;
}

.app-nav-title {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  color: inherit;
  text-decoration: none;
}

.app-nav-search {
  height: 100%;
}

.app-nav-tabs {
  height: 100%;
  align-items: stretch;
}

.app-nav-tab.v-btn {
  height: 100% !important;
  margin: 0;
  padding: 0 8px;
  border-radius: 0;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
  font-size: 15px;
  opacity: 0.95;
  transition: background-color 0.15s ease;

  .v-btn__content {
    display: flex;
    align-items: center;
  }

  .v-icon {
    opacity: 0.9;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.08);
  }
}

.app-nav-tab--active.v-btn {
  background-color: rgba(0,0,0,0.18);
  opacity: 1;
  font-weight: 700;

  .v-icon {
    opacity: 1;
  }
}

.app-nav-tab--shift.v-btn {
  background-color: #A5A5A5 !important;
}

.app-nav-tab--shift.app-nav-tab--active.v-btn {
  background-color: #8A8A8A !important;
}
</style>
